<template>
  <b-row>
    <b-col>
      <b-card>
        <b-button
          variant="outline-primary"
          class="mb-1"
          to="/app/webforms"
          pill
          size="sm"
        >
          <FeatherIcon icon="ChevronLeftIcon" /> Listeye Dön
        </b-button>
        <b-table-simple
          bordered
        >
          <b-tbody>
            <b-tr>
              <b-th class="width-200 bg-light">
                Firma Adı
              </b-th>
              <b-td>
                {{ dataItem.company }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Adı Soyadı
              </b-th>
              <b-td>
                {{ dataItem.name }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                E-Posta
              </b-th>
              <b-td>
                {{ dataItem.email }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Telefon
              </b-th>
              <b-td>
                {{ dataItem.phone }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                İlgili Ekip
              </b-th>
              <b-td>
                {{ dataItem.webform_department }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Mesaj
              </b-th>
              <b-td>
                {{ dataItem.message }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Dosya Eki
              </b-th>
              <b-td>
                <b-button
                  v-if="dataItem.attachment"
                  pill
                  size="sm"
                  variant="outline-danger"
                  :href="baseUrl + '/media/cv/' + dataItem.attachment"
                  target="_blank"
                >
                  <FeatherIcon icon="DownloadIcon" />
                  Dosyayı İndir
                </b-button>
                <div v-else>
                  -
                </div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                KVKK
              </b-th>
              <b-td :class="dataItem.kvkk === '1'? 'text-success' : 'text-danger'">
                <FeatherIcon :icon="dataItem.kvkk === '1'? 'CheckCircleIcon' : 'XCircleIcon'" />
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                IYS
              </b-th>
              <b-td :class="dataItem.kvkk === '1'? 'text-success' : 'text-danger'">
                <FeatherIcon :icon="dataItem.iys === '1'? 'CheckCircleIcon' : 'XCircleIcon'" />
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Ip Adres
              </b-th>
              <b-td>
                {{ dataItem.ip_address }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th class="width-200 bg-light">
                Gönderilme
              </b-th>
              <b-td>
                {{ moment(dataItem.created).format('DD.MM.YYYY HH:mm') }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BCard, BTableSimple, BTbody, BTr, BTh, BTd, BButton,
} from 'bootstrap-vue'

export default {
  name: 'WebformsView',
  components: {
    BRow,
    BCol,
    BCard,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BButton,
  },
  data() {
    return {
      baseUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['webforms/dataItem']
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('webforms/getDataItem', this.$route.params.id)
    },
  },
}
</script>
